import type { Key } from "react";

type PropsWithReactKey = {
    key?: Key;
    [key: string]: unknown;
};

export const splitKeyFromProps = <T extends PropsWithReactKey>(props: T): { key?: Key; props: Omit<T, "key"> } => {
    const { key, ...restProps } = props;
    return { key, props: restProps };
};
